"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var WMSMapLayerLegend = {
  TP_ZONES: {
    title: 'Territory planning zones',
    description: 'The Spatial Data is the property of the Australian Capital Territory. No part of it may in any form or by any means (electronic, mechanical, microcopying, photocopying, recording or otherwise) be reproduced, stored in a retrieval system or transmitted without prior written permission. Enquires should be directed to:<br/><br/>Director <br/>Customer Services <br/>ACT Planning and Land Authority<br/>GPO Box 1908 <br/>CANBERRA  ACT  2601<br/><br/>The Territory Plan can be accessed <a href="http://www.legislation.act.gov.au/ni/2008-27/default.asp" target="_blank" rel="noopener noreferrer nofollow" class="link">here</a>.',
    legend: [{
      colour: '#f0f0f0',
      description: 'Designated Areas',
      name: 'DES'
    }, {
      colour: '#ffb619',
      description: 'Residential - RZ1 - Suburban',
      name: 'RZ1'
    }, {
      colour: '#ffa5a5',
      description: 'Residential - RZ2 - Suburban Core',
      name: 'RZ2'
    }, {
      colour: '#ff6969',
      description: 'Residential - RZ3 - Urban Residential',
      name: 'RZ3'
    }, {
      colour: '#ff2d2d',
      description: 'Residential - RZ4 - Medium Density Residential',
      name: 'RZ4'
    }, {
      colour: '#c80000',
      description: 'Residential - RZ5 - High Density Residential',
      name: 'RZ5'
    }, {
      colour: '#ffff32',
      description: 'Community Facilities',
      name: 'CF'
    }, {
      colour: '#2e39c7',
      description: 'Commercial - CZ1 - Core',
      name: 'CZ1'
    }, {
      colour: '#637ada',
      description: 'Commercial - CZ2 - Business',
      name: 'CZ2'
    }, {
      colour: '#51a6ce',
      description: 'Commercial - CZ3 - Services',
      name: 'CZ3'
    }, {
      colour: '#00ecec',
      description: 'Commercial - CZ4 - Local Centre',
      name: 'CZ4'
    }, {
      colour: '#96ebeb',
      description: 'Commercial - CZ5 - Mixed Use',
      name: 'CZ5'
    }, {
      colour: '#caecfb',
      description: 'Commercial - CZ6 - Leisure and Accommodation',
      name: 'CZ6'
    }, {
      colour: '#f1a6ff',
      description: 'Industrial - IZ1 - General Industrial',
      name: 'IZ1'
    }, {
      colour: '#c742ff',
      description: 'Industrial - IZ2 - Industrial Mixed Use',
      name: 'IZ2'
    }, {
      colour: '#ccff00',
      description: 'Urban Parks and Recreation - PRZ1 - Urban Open Spaces',
      name: 'PRZ1'
    }, {
      colour: '#43b468',
      description: 'Urban Parks and Recreation - PRZ2 - Restricted Access Recreation',
      name: 'PRZ2'
    }, {
      colour: '#d2d2d2',
      description: 'Transport and Services - TSZ1 - Transport',
      name: 'TSZ1'
    }, {
      colour: '#808080',
      description: 'Transport and Services - TSZ2 - Services',
      name: 'TSZ2'
    }, {
      colour: '#ffffc0',
      description: 'Non Urban - NUZ1 - Broadacre',
      name: 'NUZ1'
    }, {
      colour: '#ffe3a8',
      description: 'Non Urban - NUZ2 - Rural',
      name: 'NUZ2'
    }, {
      colour: '#b5c73e',
      description: 'Non Urban - NUZ3 - Hills, Ridges and Buffers',
      name: 'NUZ3'
    }, {
      colour: '#d3f986',
      description: 'Non Urban - NUZ4 - River Corridor',
      name: 'NUZ4'
    }, {
      colour: '#a2d6ba',
      description: 'Non Urban - NUZ5 - Mountain and Bushlands',
      name: 'NUZ5'
    }]
  },
  EASEMENTS: {
    title: 'Easement information',
    description: 'Easements shown on this site are those easements, or proposed easements, as shown on deposited plans. The legal status of these easements may vary. There may also be other easements, particularly those created by separate legal instrument, which are not shown on this site.',
    legend: [{
      colour: '#ddd900',
      description: 'Electrical',
      name: 'Electrical'
    }, {
      colour: '#f38fc4',
      description: 'Gas',
      name: 'Gas'
    }, {
      colour: '#84c154',
      description: 'Right Of Way',
      name: 'Right Of Way'
    }, {
      colour: '#ec624c',
      description: 'Sewer',
      name: 'Sewer'
    }, {
      colour: '#4646ff',
      description: 'Stormwater',
      name: 'Stormwater'
    }, {
      colour: '#f09332',
      description: 'Telecommunications',
      name: 'Telecommunications'
    }, {
      colour: '#5ecdf3',
      description: 'Water',
      name: 'Water'
    }]
  },
  CONTOURS: {
    title: 'Land contours',
    description: 'Contours are based on 2015 data and should not be used for design work.',
    legend: [{
      className: 'ten-metre-contour',
      description: '10 Metre',
      name: '10 Metre'
    }, {
      className: 'two-metre-contour',
      description: '2 Metre',
      name: '2 Metre'
    }]
  },
  ACT_SCHOOLS: {
    title: 'ACT public school priority enrolment areas (2020)',
    description: 'The information on ACT public school priority enrolment areas is provided by the ACT Education Directorate and should be used as a guide only. Full information on zones can be found <a href="https://www.education.act.gov.au/public-school-life/enrolling-in-a-public-school/priority_placement_areas" target="_blank" rel="noopener noreferrer nofollow" class="link">here</a>.'
  }
};
var _default = exports.default = WMSMapLayerLegend;